import { z } from 'zod';
const FileProofSchema = z.object({
    id: z.string(),
    fileName: z.string(),
    pspId: z.string(),
    mediaType: z.string(),
    bucket: z.string(),
    uploadDate: z.date(),
    uploaderIp: z.string(),
    fileKey: z.string(),
    fileEtag: z.string(),
    fileSize: z.number(),
    proofSide: z.enum(['front', 'back']),
});
const OrganizationMemberHomeLocationSchema = z.object({
    addressCountry: z.string(),
    addressLocality: z.string(),
    addressRegion: z.string().optional(),
    postalCode: z.string(),
    streetAddress: z.string(),
});
const OrganizationMemberSchema = z.object({
    id: z.string(),
    pspId: z.string(),
    givenName: z.string(),
    familyName: z.string(),
    birthDate: z.string(),
    homeLocation: OrganizationMemberHomeLocationSchema,
    email: z.string(),
    telephone: z.string(),
    jobTitle: z.string(),
    isDirector: z.boolean(),
    isOwner: z.boolean(),
    isExecutive: z.boolean(),
    proofs: z.array(FileProofSchema),
});
const OrganizationAddressSchema = z.object({
    address: z.string(),
    city: z.string(),
    country: z.string(),
    province: z.string().optional(),
    zip: z.string(),
});
const FeesSchema = z.object({
    flat: z.number(),
    percent: z.number(),
});
const ZoneFeesSchema = z
    .object({
    default: FeesSchema,
})
    .catchall(FeesSchema);
const OrganizationPlanStandardSchema = z.object({
    name: z.enum(['start', 'grow', 'prime']),
    updatedBy: z.string().optional(),
});
const OrganizationPlanCustomSchema = z.object({
    name: z.literal('custom'),
    amount: z.number(),
    fees: z.object({
        europe: ZoneFeesSchema,
        others: ZoneFeesSchema,
    }),
    updatedBy: z.string().optional(),
});
const OrganizationPlanSchema = z.union([OrganizationPlanStandardSchema, OrganizationPlanCustomSchema]);
const PersonalInformationSchema = z.object({
    first_name: z.string(),
    last_name: z.string(),
    date_of_birth: z.string().optional(),
    gender: z.enum(['m', 'f', 'o']).optional(),
});
export const OrganizationSchema = z.object({
    activityCountry: z.string(),
    address: OrganizationAddressSchema,
    crmId: z.string().optional(),
    mcc: z.string(),
    members: z.array(OrganizationMemberSchema),
    id: z.string(),
    personal_informations: PersonalInformationSchema,
    phone: z.string(),
    plan: OrganizationPlanSchema,
    proofs: z.array(FileProofSchema),
    taxId: z.string(),
    tva_number: z.string(),
    type: z.literal('organization'),
    website: z.string(),
    yearlyTurnover: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
    deletedAt: z.date().optional(),
});
//# sourceMappingURL=organization.js.map